import { JAB } from '../cards/attack/jab';
import { PANDEMIC } from '../cards/support/pandemic';
import { PLAGUE } from '../cards/support/plague';
import { VENOM } from '../cards/support/venom';
import type { EnemyTemplate } from './template';

/** HEX-23 archetype ported (ADR-0015 §4, §15). Epic tier (HEX-78 re-tier from
 * rare): 4×3 grid, 4 dice. Its poison cards are now scored by the epic
 * `boardScore` AI (ADR-0016 §4), so the spider stacks DoT rather than swinging
 * Jab blindly. Pandemic (epic) anchors the §4 tier-quality floor — Poison plus
 * a Weaken stack in one play. */
export const CAVE_SPIDER: EnemyTemplate = {
  id: 'cave-spider',
  name: 'Cave Spider',
  glyph: '✶', // many-legged star — the skittering spider
  tier: 'epic',
  hp: 22,
  loadout: [
    { card: PANDEMIC, origin: { row: 0, col: 0 }, rotated: false },
    { card: VENOM, origin: { row: 0, col: 2 }, rotated: false },
    { card: PLAGUE, origin: { row: 2, col: 0 }, rotated: false },
    { card: JAB, origin: { row: 2, col: 2 }, rotated: false },
  ],
  drops: { gold: 8 },
};
